export function populateSeoTemplateString(
  tmpl: string,
  templateVariables: Map<string, string>,
  stringVariables: Map<string, string>,
): string {
  let result = tmpl;

  for (const [key, value] of stringVariables) {
    const str = `${key}${value === '' ? ' ' : ''}`;
    result = result.replace(str, value);
  }

  if (templateVariables.size > 0) {
    const tokenRegexpStr = `(?:@(${Array.from(templateVariables.keys()).join('|')});)`;
    const tokenRegexp = new RegExp(tokenRegexpStr, 'gm');
    result = tmpl.replace(tokenRegexp, (m, variableToken) => templateVariables.get(variableToken) ?? m);
  }

  return result;
}
